import React, { useState } from 'react'
import { useStyles } from './styles'
import { Grid } from '@material-ui/core'
import { badIcon, goodIcon, veryBadIcon, veryGoodIcon } from 'src/assets/images'

interface OptionCardGroupProps {
  label: string
  selectedValue: 'very_good' | 'good' | 'bad' | 'very_bad'
  onSelect: (value: 'very_good' | 'good' | 'bad' | 'very_bad') => void
}

interface ClassificationOption {
  label: string
  value: 'very_good' | 'good' | 'bad' | 'very_bad'
  icon: string
}

const classificationOptions: ClassificationOption[] = [
  { label: 'Muito boa', value: 'very_good', icon: veryGoodIcon },
  { label: 'Boa', value: 'good', icon: goodIcon },
  { label: 'Ruim', value: 'bad', icon: badIcon },
  { label: 'Muito ruim', value: 'very_bad', icon: veryBadIcon }
]

export const ClassificationSelect: React.FC<OptionCardGroupProps> = ({ label, selectedValue, onSelect }) => {
  const [selected, setSelected] = useState<ClassificationOption>(
    classificationOptions.find((option) => option.value === selectedValue)!
  )
  const style = useStyles()

  return (
    <div className={style.boxSelectGroup}>
      <span className={style.sectionLabel}>{label}</span>
      <Grid container spacing={3}>
        {classificationOptions.map((option) => {
          return (
            <Grid item xs={12} sm={6} md={4} key={option.value}>
              <div
                className={`${style.boxSelectDiv} ${selected.value === option.value ? style.boxSelectDivSelected : ''}`}
                onClick={() => {
                  const newValue = option.value
                  setSelected(classificationOptions.find((option) => option.value === newValue)!)
                  onSelect(newValue)
                }}
              >
                <div className={style.boxSelectContent}>
                  <img src={option.icon} alt={`Emoticon ${option.label}`} className={style.boxSelectEmoji} />
                  <label className={style.boxSelectLabel}>{option.label}</label>
                </div>
              </div>
            </Grid>
          )
        })}
      </Grid>
    </div>
  )
}
